<template>
  <div class="filter-wrapper">
    <div class="filter-input">
      <div>
        <v-autocomplete outline flat dense hide-details height="38" :items="channelList" v-model="filter.channel"
                        placeholder="Channel" item-text="text" style="width: 180px"
                        @change="onRefresh"
                        item-value="value" clearable :append-icon='`${filter.channel ? "" : $vuetify.icons.dropdown}`'>
        </v-autocomplete>
      </div>
    </div>
    <div class="filter-input">
      <div>
        <v-autocomplete outline flat dense hide-details :items="skillsFilterItems" v-model="filter.skills"
                        multiple chips box
                        @change="onRefresh"
                        placeholder="Skill" item-text="text"
                        item-value="value" :append-icon='`${filter.channel ? "" : $vuetify.icons.dropdown}`'>
          <template v-slot:selection="data">
            <v-chip
                small
                :selected="data.selected"
                close
                class="chip--select-multi"
                @input="remove(data.item)"
            >
              {{ data.item.text }}
            </v-chip>
          </template>
        </v-autocomplete>
      </div>
    </div>
    <div class="filter-input">
      <DatePickerOutline
          flat
          v-model="filter.from"
          :max="filter.to"
          hide-details
          append-icon="mdi-calendar"
          prepend-inner-icon=""
          @change="onRefresh"
      />
    </div>
    <div class="filter-input">
      <DatePickerOutline
          flat
          hide-details
          append-icon="mdi-calendar"
          v-model="filter.to"
          :min="filter.from"
          :max="today"
          prepend-inner-icon=""
          @change="onRefresh"
      />
    </div>
    <v-btn color="primary" depressed class="text-none" @click="onRefresh">
      <v-icon size="16" class="pr-1">mdi-sync</v-icon>
      Refresh
    </v-btn>
  </div>
</template>

<script>
import $const from "@/utils/const";
import upperFirst from "lodash/upperFirst";
import {sync} from "vuex-pathify";
import DatePickerOutline from "components/custom/DatePickerOutline";
import moment from "moment";
import {mapGetters} from "vuex";

export default {
  name: "OverviewReportFilterBox",
  components: {
    DatePickerOutline
  },
  data() {
    return {
      today: moment().format('YYYY-MM-DD'),
    }
  },
  computed: {
    ...mapGetters('overviewReport', ['skillsFilterItems']),
    filter: sync('overviewReport/filter'),
    channelList() {
      return $const.ALL_CHAT_CHANNELS.map(o => {
        return {text: upperFirst(this.$t(o)), value: o}
      })
    }
  },
  methods: {
    remove (item) {
      const index = this.filter.skills.indexOf(item.value)
      if (index >= 0) this.filter.skills.splice(index, 1)
    },
    onRefresh() {
      this.$emit('onRefresh')
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep.v-text-field--outline > .v-input__control > .v-input__slot {
  min-height: 38px;
}

::v-deep.theme--light.v-text-field--outline > .v-input__control > .v-input__slot {
  border: 1px solid #D9D9D9 !important;
}

::v-deep.v-autocomplete.v-text-field--enclosed:not(.v-text-field--solo):not(.v-text-field--single-line) .v-select__slot > input {
  margin-top: 0 !important;
}

::v-deep.v-text-field--outline > .v-input__control > .v-input__slot {
  background-color: white !important;
}

::v-deep.v-text-field .v-input__append-inner {
  margin-top: 8px !important;
}

::v-deep input {
  font-size: 14px;
}
::v-deep i {
  font-size: 20px !important;
}
::v-deep.v-select.v-select--chips:not(.v-text-field--single-line).v-text-field--box .v-select__selections, .v-select.v-select--chips:not(.v-text-field--single-line).v-text-field--enclosed .v-select__selections {
  min-height: 38px !important;
}
::v-deep.v-select.v-text-field--enclosed:not(.v-text-field--single-line) .v-select__selections {
  padding-top: 0px !important;
}
.filter-wrapper {
  display: flex;
  gap: 10px;

  .filter-input {
    height: 38px;
  }

  button {
    margin: 0 6px;
    height: 38px;
    border-radius: 5px;
  }
}
</style>